import React from "react";
import { Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Image, Placeholder, Transformation } from "cloudinary-react";
import "bootstrap/dist/css/bootstrap.min.css";
import AvailabilitySmall from "../Components/Tour/AvailabilitySmall";

const Tour = ({ tour }) => {
  const current = new Date();

  if (!tour.enabled) return null;

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            name: tour.title,
            description: tour.description,
            brand: { "@type": "Brand", name: "American Legacy Tours" },
            image: `https://res.cloudinary.com/american-legacy-tours/image/upload/f_auto,q_auto${tour.picturePath}`,
            offers: {
              "@type": "Offer",
              url: `https://www.americanlegacytours.com/${tour.pathTitle}`,
              price: tour.price,
              priceCurrency: "USD",
              availability: "https://schema.org/InStock",
              priceValidUntil: `12/31/${current.getFullYear()}`,
            },
          })}
        </script>
      </Helmet>

      <Col xl={3} lg={4} md={6} sm={6} xs={6} className="tour-card-col">
        <div className="tour-card">
          <a href={tour.pathTitle} className="tour-card__img-wrap">
            <Image
              cloudName="american-legacy-tours"
              publicId={tour.picturePath}
              loading="lazy"
              fetch_format="auto"
              quality="auto"
              title={tour.title}
            >
              <Placeholder type="predominant" />
              <Transformation height="420" width="300" crop="fill" />
            </Image>
            {tour.price && (
              <span className="tour-card__price">From ${tour.price}</span>
            )}
          </a>

          <div className="tour-card__body">
            <h3 className="tour-card__title">{tour.title}</h3>
            <a href={tour.pathTitle} className="tour-card__cta">
              Learn More
            </a>
          </div>

          <div className="tour-card__avail">
            <AvailabilitySmall
              thundertixId={tour.thundertixId}
              slug={tour.pathTitle}
            />
          </div>
        </div>
      </Col>
    </>
  );
};

export default Tour;
